import { render } from "./DetalharProduto.vue?vue&type=template&id=3dee3c22&scoped=true"
import script from "./DetalharProduto.vue?vue&type=script&lang=js"
export * from "./DetalharProduto.vue?vue&type=script&lang=js"

import "./DetalharProduto.vue?vue&type=style&index=0&id=3dee3c22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dee3c22"]])

export default __exports__